export const numberedItemsTexts = [
  `Extended HRV dataset 
with 19 key metrics`,
  `Export of both raw 
and processed data`,
  `Full access to raw data`,
  `Special prices for licenses`,
  `Guaranty of privacy and security of your study
and data
`,
  `Free access to IOS
and Android apps for studies participants`,
  `Up to 12 months for
research conducting`,
  `Technical assistance during your research`,
];

export const imagesWithText = [
  {
    image: 'covid.svg',
    text: `COVID-19 
patterns`,
  },
  {
    image: 'diagnostcs.svg',
    text: `Early 
diagnostics`,
  },
  {
    image: 'detection.svg',
    text: `Psychosomatic 
detection`,
  },
  {
    image: 'response.svg',
    text: `Response 
to treatment`,
  },
  {
    image: 'recovery.svg',
    text: `Signs of recovery 
after a disease`,
  },
  {
    image: 'conditions.svg',
    text: `Identifying critical 
conditions`,
  },
];
